import { Card, Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Edit from './Edit';
import Delete from './Delete';

export default function AnnouncementCard({ announcement, getAnnouncements }) {

  const { user: authUser } = useSelector(x => x.auth);
  const [isEditing, setIsEditing] = useState(false);
  const [toggleBusy, setToggleBusy] = useState(false);
  const isOfficer = authUser?.user.acl === "Officer";
  const isActive = announcement?.active !== false;
  const url = process.env.REACT_APP_URL;

  const handleToggleActive = async () => {
    if (!announcement?._id || toggleBusy || !isOfficer) return;

    setToggleBusy(true);
    try {
      const response = await fetch(`${url}/announcement/${announcement._id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authUser?.token}`,
        },
        body: JSON.stringify({ active: !isActive }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData?.error || 'Failed to update announcement status.');
      }

      toast.success(`Announcement ${isActive ? 'disabled' : 'activated'} successfully.`);
      getAnnouncements();
    } catch (error) {
      toast.error(error?.message || 'Failed to update announcement status.');
    } finally {
      setToggleBusy(false);
    }
  };

  return (
    <>
      {isOfficer && isEditing ? (
        <>
          <Edit
            announcement={announcement}
            getAnnouncements={getAnnouncements}
            showEditButton={false}
            onCancel={() => setIsEditing(false)}
            onSave={() => setIsEditing(false)}
          />
          <Delete
            announcement={announcement}
            getAnnouncements={getAnnouncements}
            showDeleteButton={true}
            buttonClassName="announcements-action-btn announcements-action-btn--danger"
            onDelete={() => setIsEditing(false)}
            onCancel={() => setIsEditing(false)}
          />
        </>
      ) : (
        <Card id={`${announcement._id}-card`} className="announcements-item-card">
          <Card.Header className="announcements-item-header">
            <div className="announcements-item-title-wrap">
              <h4 className="announcements-item-title">{announcement.title}</h4>
            </div>
            <div className="announcements-header-pills">
              <span className="announcements-audience-pill">{announcement.to || 'Public'}</span>
              <span className={`announcements-active-pill ${isActive ? 'is-active' : 'is-disabled'}`}>
                {isActive ? 'Active' : 'Disabled'}
              </span>
            </div>
          </Card.Header>

          <Card.Body className="announcements-item-body">
            {announcement.shortDescription && (
              <div
                className="announcements-item-short"
                dangerouslySetInnerHTML={{ __html: announcement.shortDescription }}
              ></div>
            )}
            <div
              className="announcements-item-full"
              dangerouslySetInnerHTML={{ __html: announcement.description }}
            ></div>
          </Card.Body>

          {isOfficer && (
            <Card.Footer className="announcements-item-footer">
              <Row>
                <Col xs={12} className="announcements-item-actions">
                  <button
                    type="button"
                    className={`announcements-action-btn ${isActive ? 'announcements-action-btn--neutral' : 'announcements-action-btn--success'}`}
                    onClick={handleToggleActive}
                    disabled={toggleBusy}
                  >
                    {toggleBusy ? 'Saving...' : (isActive ? 'Disable' : 'Activate')}
                  </button>
                  <Edit
                    announcement={announcement}
                    getAnnouncements={getAnnouncements}
                    showEditButton={true}
                    buttonClassName="announcements-action-btn announcements-action-btn--edit"
                    onEdit={() => setIsEditing(true)}
                  />
                  <Delete
                    announcement={announcement}
                    getAnnouncements={getAnnouncements}
                    showDeleteButton={true}
                    buttonClassName="announcements-action-btn announcements-action-btn--danger"
                    onDelete={() => getAnnouncements()}
                  />
                </Col>
              </Row>
            </Card.Footer>
          )}
        </Card>
      )}
    </>
  )
}